import React, { useState, useEffect } from 'react';
import './QuickButtonUpdateModal.css';

const QuickButtonUpdateModal = ({ isOpen, onClose, onSuccess, API_URL }) => {
    const [quickButtons, setQuickButtons] = useState([]);
    const [selectedButton, setSelectedButton] = useState(null);
    const [buttonText, setButtonText] = useState('');
    const [buttonUrl, setButtonUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (isOpen) {
            fetchQuickButtons();
        }
    }, [isOpen]);

    const fetchQuickButtons = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/quick-buttons?limit=100`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setQuickButtons(data);
            } else {
                setError('Quick buttons yüklenemedi');
            }
        } catch (err) {
            console.error('Quick buttons yüklenemedi:', err);
            setError('Quick buttons yüklenemedi');
        }
    };

    const handleButtonSelect = (button) => {
        setSelectedButton(button);
        setButtonText(button.button_text);
        setButtonUrl(button.button_url);
        setError('');
    };

    const handleUpdate = async () => {
        if (!selectedButton) {
            setError('Lütfen güncellenecek bir buton seçin');
            return;
        }

        if (!buttonText.trim() || !buttonUrl.trim()) {
            setError('Buton metni ve URL zorunludur');
            return;
        }

        try {
            new URL(buttonUrl);
        } catch (e) {
            setError('Geçerli bir URL girin');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/quick-buttons/${selectedButton.id}/update-all`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    text: buttonText.trim(),
                    url: buttonUrl.trim()
                })
            });

            const data = await response.json();

            if (response.ok) {
                onSuccess(data);
                handleClose();
            } else {
                setError(data.error || 'Güncelleme başarısız');
            }
        } catch (err) {
            console.error('Güncelleme hatası:', err);
            setError('Güncelleme sırasında bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSelectedButton(null);
        setButtonText('');
        setButtonUrl('');
        setError('');
        setSearchTerm('');
        onClose();
    };

    const filteredButtons = quickButtons.filter(btn => 
        btn.button_text.toLowerCase().includes(searchTerm.toLowerCase()) ||
        btn.button_url.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!isOpen) return null;

    return (
        <div className="qb-modal-overlay" onClick={handleClose}>
            <div className="qb-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="qb-modal-header">
                    <h2>Hızlı Buton Güncelle</h2>
                    <button className="qb-modal-close" onClick={handleClose}>×</button>
                </div>

                <div className="qb-modal-body">
                    {error && (
                        <div className="qb-error-message">
                            {error}
                        </div>
                    )}

                    {/* Buton Seçimi */}
                    {!selectedButton ? (
                        <div>
                            <div className="qb-form-group">
                                <label>Güncellenecek Butonu Seçin</label>
                                <input
                                    type="text"
                                    placeholder="Buton ara..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="qb-search-input"
                                />
                            </div>

                            <div className="qb-buttons-list">
                                {filteredButtons.length === 0 ? (
                                    <div className="qb-empty-state">
                                        {searchTerm ? 'Buton bulunamadı' : 'Henüz hızlı buton eklenmemiş'}
                                    </div>
                                ) : (
                                    filteredButtons.map(button => (
                                        <div
                                            key={button.id}
                                            onClick={() => handleButtonSelect(button)}
                                            className="qb-button-item"
                                        >
                                            <div className="qb-button-text">
                                                {button.button_text}
                                            </div>
                                            <div className="qb-button-url">
                                                {button.button_url}
                                            </div>
                                            <div className="qb-button-usage">
                                                Kullanım: {button.usage_count} kez
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="qb-selected-button">
                                <div className="qb-selected-label">
                                    Seçili Buton:
                                </div>
                                <div className="qb-selected-text">
                                    {selectedButton.button_text}
                                </div>
                                <div className="qb-selected-url">
                                    {selectedButton.button_url}
                                </div>
                                <button
                                    onClick={() => handleButtonSelect(null)}
                                    className="qb-change-button"
                                >
                                    Farklı Buton Seç
                                </button>
                            </div>

                            <div className="qb-form-group">
                                <label>Yeni Buton Metni</label>
                                <input
                                    type="text"
                                    value={buttonText}
                                    onChange={(e) => setButtonText(e.target.value)}
                                    placeholder="Örn: Web Sitemizi Ziyaret Edin"
                                    className="qb-input"
                                    maxLength={100}
                                />
                            </div>

                            <div className="qb-form-group">
                                <label>Yeni Buton URL</label>
                                <input
                                    type="url"
                                    value={buttonUrl}
                                    onChange={(e) => setButtonUrl(e.target.value)}
                                    placeholder="https://example.com"
                                    className="qb-input"
                                />
                            </div>

                            <div className="qb-warning">
                                <strong>⚠️ Uyarı:</strong> Bu butonu kullanan tüm içerikler otomatik olarak güncellenecektir.
                            </div>
                        </div>
                    )}
                </div>

                <div className="qb-modal-footer">
                    <button
                        className="qb-btn qb-btn-secondary"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        İptal
                    </button>
                    {selectedButton && (
                        <button
                            className="qb-btn qb-btn-primary"
                            onClick={handleUpdate}
                            disabled={loading || !buttonText.trim() || !buttonUrl.trim()}
                        >
                            {loading ? 'Güncelleniyor...' : 'Güncelle'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuickButtonUpdateModal;